import { motion } from 'motion/react'
import ActionButton from 'src/components/ActionButton'
import Icon from 'src/components/Icon'
import Picture from 'src/components/Picture'
import RichText from 'src/components/RichText'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

export const Container = styled(motion.article)<{ $color?: string }>`
  --perspective-color: ${({ $color }) => $color};
  --perspective-translate-x__close: ${pxToRem(16)};
  position: relative;
  overflow: hidden;
`
export const Details = styled(motion.div)`
  position: absolute;
  inset-block-end: -1px; // to prevent pixel rounding making a space appear
  inset-inline-end: -1px; // to prevent pixel rounding making a space appear
  z-index: 5;
  width: 92%;
  background-color: ${({ theme }) => theme.colors.white};
`
export const Summary = styled.div`
  position: relative;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  list-style: none;
  padding-inline: ${pxToRem(16)} ${pxToRem(56)};
  padding-block: ${pxToRem(24)} ${pxToRem(24)};
  cursor: pointer;
  &::-webkit-details-marker {
    display: none;
  }
  &:focus-visible {
    outline: none;
  }
`
export const Title = styled.h3`
  ${({ theme }) => theme.textStyles.m375_h3}
  text-wrap: balance;
  padding-inline-end: 20%;
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.d1440_h3}
  }
`
export const Toggle = styled(motion.div)`
  position: absolute;
  inset-block-start: ${pxToRem(24)};
  inset-inline-end: ${pxToRem(24)};
  padding-inline-end: 20%;
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: auto;
  grid-template-columns: auto;
`
export const _Icon = styled(Icon)`
  grid-column: 1;
  grid-row: 1;
  aspect-ratio: 1;
  width: ${pxToRem(24)};
  opacity: 0;
  transition: rotate 0.3s ease-in-out;
`
export const OpenIcon = styled(motion.create(_Icon))`
  ${Summary}:not([aria-expanded='true']) & {
    opacity: 1;
  }
`
export const CloseIcon = styled(_Icon)`
  ${Summary}[aria-expanded='true'] & {
    opacity: 1;
  }
`
// this exists only so that the whole block is clickable
// this might be overcomplicated and unperformant
// possible 💩
export const Clickable = styled.div`
  position: absolute;
  inset: 0;
  opacity: 1;
  pointer-events: none;
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 100vw;
    height: 300vh;
    pointer-events: all;
  }
  &::after {
    inset-block-end: 100%;
    inset-inline-end: 0;
  }
  &::before {
    inset-block-end: 0;
    inset-inline-end: 100%;
  }
`
export const Wrapper = styled(motion.div)<{ $height?: number }>`
  --perspective__height--content: ${({ $height }) =>
    $height ? `${$height}px` : pxToRem(250)};
  display: block;
  visibility: visible;
  opacity: 1;
  overflow: visible;
`
export const Content = styled(motion.div)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  overflow: hidden;
  height: auto;
  padding-inline: ${pxToRem(16)} 20%;
  padding-block: ${pxToRem(0)} ${pxToRem(24)};
  box-sizing: border-box;
`
export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.d1440_body}
`
export const _ActionButton = styled(ActionButton)`
  margin-block-start: ${pxToRem(8)};
`
export const _Picture = styled(motion.create(Picture))`
  position: relative;
  z-index: 1;
  display: block;
`
